import React from 'react';
import { Users, FileText, Clock, Eye, Trash2, MapPin } from 'lucide-react';

const GroupeCard = ({ groupe, onView, onDelete }) => {
  const defaultCover = 'linear-gradient(135deg, #FF6B00 0%, #437011 100%)';

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300">
      {/* Image de couverture */}
      <div
        className="h-32 w-full"
        style={{
          background: groupe.couverture_url 
            ? `url(${groupe.couverture_url}) center/cover` 
            : defaultCover
        }}
      />

      <div className="p-5">
        {/* Titre et description */}
        <div className="mb-4">
          <h3 className="text-xl font-bold text-gray-900 mb-2 line-clamp-1">
            {groupe.titre}
          </h3>
          {groupe.description && (
            <p className="text-gray-600 text-sm line-clamp-2">
              {groupe.description}
            </p>
          )}
        </div>

        {/* Région */}
        {groupe.region && (
          <div className="flex items-center gap-2 mb-3">
            <MapPin className="w-4 h-4 text-gray-400" />
            <span className="text-sm text-gray-600">{groupe.region}</span>
          </div>
        )}

        {/* Admin */}
        {groupe.admin_info && (
          <div className="flex items-center gap-2 mb-4 pb-4 border-b border-gray-200">
            <img
              src={groupe.admin_info.image || '/default-avatar.png'}
              alt={groupe.admin_info.username}
              className="w-8 h-8 rounded-full object-cover"
            />
            <div>
              <p className="text-xs text-gray-500">Administrateur</p>
              <p className="text-sm font-semibold text-gray-900">
                {groupe.admin_info.full_name}
              </p>
            </div>
          </div>
        )}

        {/* Statistiques */}
        <div className="grid grid-cols-3 gap-2 mb-4 p-3 bg-[#F4F8E9] rounded-lg">
          <div className="text-center">
            <div className="flex justify-center mb-1">
              <Users className="w-4 h-4 text-[#437011]" />
            </div>
            <p className="text-lg font-bold text-[#437011]">{groupe.membres_count}</p>
            <p className="text-xs text-gray-600">Membres</p>
          </div>
          <div className="text-center">
            <div className="flex justify-center mb-1">
              <FileText className="w-4 h-4 text-[#437011]" />
            </div>
            <p className="text-lg font-bold text-[#437011]">{groupe.publications_count}</p>
            <p className="text-xs text-gray-600">Publications</p>
          </div>
          <div className="text-center">
            <div className="flex justify-center mb-1">
              <Clock className="w-4 h-4 text-[#437011]" />
            </div>
            <p className="text-lg font-bold text-[#437011]">{groupe.demandes_count}</p>
            <p className="text-xs text-gray-600">Demandes</p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-2">
          <button
            onClick={() => onView(groupe)}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            <Eye className="w-4 h-4" />
            <span>Voir</span>
          </button>
          <button
            onClick={() => onDelete(groupe.id)}
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupeCard;
